/**
 * Collapsible legend for amber idle highlighting on CRM list and board.
 */

import React, { useState } from 'react'
import { Link } from 'react-router-dom'

export default function CrmIdleLegend({ children }) {
  const [open, setOpen] = useState(false)

  return (
    <div className="mb-4 border-b border-gray-200">
      <div className="flex flex-wrap items-end justify-between gap-x-4 gap-y-1">
        {children}
        <button
          type="button"
          onClick={() => setOpen((visible) => !visible)}
          className="inline-flex shrink-0 items-center gap-1.5 pb-2 text-xs text-gray-600 hover:text-gray-900 underline decoration-dotted underline-offset-2"
          aria-expanded={open}
          aria-controls="crm-idle-legend"
        >
          <span
            className="inline-flex size-4 shrink-0 items-center justify-center rounded-full border border-gray-300 bg-gray-50 text-[10px] font-semibold text-gray-600"
            aria-hidden
          >
            ?
          </span>
          {open ? 'Hide idle highlight legend' : 'What does the yellow highlight mean?'}
        </button>
      </div>
      {open ? (
        <p
          id="crm-idle-legend"
          className="mb-2 flex flex-wrap items-center gap-x-2 gap-y-1.5 rounded-md border border-gray-200 bg-gray-50/80 px-3 py-2 text-xs text-gray-600"
        >
          <span className="inline-flex items-center gap-1.5 rounded-md border border-amber-200 bg-amber-50/80 px-2 py-1 font-medium text-amber-900">
            <span
              className="size-2.5 shrink-0 rounded-sm border border-amber-300 bg-amber-200"
              aria-hidden
            />
            Idle case
          </span>
          <span>
            Yellow rows or cards mean no activity for longer than the idle threshold for that
            status. Use the <strong className="font-medium text-gray-700">Idle</strong> column or{' '}
            <strong className="font-medium text-gray-700">Idle only</strong> filter to focus on
            them.{' '}
            <Link to="/hub/crm/settings" className="text-green-700 underline hover:no-underline">
              CRM Settings
            </Link>{' '}
            defines the day thresholds.
          </span>
        </p>
      ) : null}
    </div>
  )
}
